<template>
  <vs-popup title="Transférer une requête dans un dossier" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-col vs-w="12">
        <span style="margin-left: -10px">Liste des dossiers</span>
        <v-select style="margin-left: -10px" v-model="form.folder_id" class="w-full" label="name"
                  placeholder="Sélectionner un dossier"
                  :reduce="folder => folder.id"
                  :options="folders"></v-select>
        <span style="color: red" v-if="errors_data.folder_id">Selectionner un dossier</span>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-button color="primary" class="mt-2 mr-2" type="filled" @click="addRequestToFolder()">Ajouter</vs-button>
      <vs-button color="primary" class="mt-2" type="border" @click="$emit('closeFolder')">Annuler</vs-button>
    </vs-row>
  </vs-popup>
</template>

<script>
  const search_temp = {
    request_id: '',
    folder_id: ''
  }
  export default {
    name: "transferredFolder",
    props: {
      isPromptActive: {
        type: Boolean,
        required: true
      },
      folders:{
        type: Array,
        required: true
      },
      getRequests_detail_information:{
        type: Function
      }
    },
    data: () => ({
      form:{
        request_id: '',
        folder_id: '',
      },
      errors_data: []
    }),
    watch: {
      isPromptActive(val) {
        if (!val) return;
      }
    },
    computed: {
      isPromptActiveLocal: {
        get() {
          return this.isPromptActive
        },
        set(val) {
          this.errors_data = []
          if (!val) {
            this.$emit('closeFolder')
          }
        }
      },
    },
    methods:{
      addRequestToFolder(){
        this.$vs.loading()
        this.form.request_id = this.$route.params.id
        this.$http.post('/folders/transferred', this.form).then((response) => {
          this.$vs.loading.close()
          if (response.data.status){
            this.form = { ...search_temp }
            this.$emit('closeFolder')
            this.getRequests_detail_information(this.$route.params.id)
            this.$vs.notify({
              title: 'Transfert de requête',
              text: 'Opération effectuée',
              color: 'success',
              position: 'top-right'
            })
          }else {
            this.$vs.notify({
              title: 'Transfert de requête',
              text: 'Opération echouée',
              color: 'danger',
              position: 'top-right'
            })
          }
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }else this.errors_data = error.response.data.errors
        })
      }
    }
  }
</script>

<style scoped>

</style>
